import { FC } from 'react';
import { Icon } from 'icons';
import Styles from './star-rating.module.scss';

interface StarRatingProps {
  rating: number;
  onChange: (rating: number) => void;
  disabled?: boolean;
}

export const StarRating: FC<StarRatingProps> = ({ rating, onChange, disabled }) => {
  return (
    <div className={Styles.starRating}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Icon
          key={star}
          name={star <= rating ? 'star' : 'star_outline'}
          size={24}
          className={disabled ? Styles.disabled : Styles.star}
          onClick={() => !disabled && onChange(star)}
        />
      ))}
    </div>
  );
}; 